<template>
   <button style="display:none" :data-logout="ShowLogOut" v-show="ShowLogOut" v-on:click="$parent.LogOut()" class="btn btn-icon btn-warning" title="Se déconnecter"><img src="data:image/svg+xml;base64,
PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNTA4LjUyIDUwOC41MiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTA4LjUyIDUwOC41MjsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiBjbGFzcz0iIj48Zz48Zz4KCTxnPgoJCTxnPgoJCQk8cGF0aCBzdHlsZT0iZmlsbDojRkZGRkZGIiBkPSJNNDQ0Ljk1NSwxOTAuNjk1aC0yODguNDlWMTYxLjM2YzAtNTMuOTM1LDQzLjg2LTk3Ljc5NSw5Ny43OTUtOTcuNzk1ICAgICBjMzUuNTMzLDAsNjYuNDU3LDE5LjE5Nyw4My41NTYsNDcuNjQybDAuNjM2LTAuNDc3YzUuODE2LDguMiwxNC44NzQsMTMuOTIxLDI1LjY0OCwxMy45MjFjMTcuNTQ0LDAsMzEuNzgzLTE0LjIzOSwzMS43ODMtMzEuNzgyICAgICBjMC00LjI5MS0wLjg5LTguMzkxLTIuNDQ3LTEyLjE0MWwtMC4zNS0wLjY5OWMtMS4zOTgtMy4xNzgtMy40MDEtNS45NzUtNS43ODQtOC40ODZDMzU4LjM0NywyOC42MDQsMzA5Ljk0MywwLDI1NC4yNiwwICAgICBDMTY1LjE0MiwwLDkyLjksNzIuMjQyLDkyLjksMTYxLjM2djI5LjMzNUg2My41NjVjLTE3LjU0NCwwLTMxLjc4MiwxNC4yMzktMzEuNzgyLDMxLjc4MnYyNTQuMjYgICAgIGMwLDE3LjU0NCwxNC4yMzksMzEuNzgyLDMxLjc4MiwzMS43ODJoMzgxLjM5YzE3LjU0NCwwLDMxLjc4Mi0xNC4yMzksMzEuNzgyLTMxLjc4MnYtMjU0LjI2ICAgICBDNDc2LjczNywyMDQuOTMzLDQ2Mi40OTksMTkwLjY5NSw0NDQuOTU1LDE5MC42OTV6IE0yNTQuMjYsNDEzLjE3MmMtMzUuMTIsMC02My41NjUtMjguNDQ1LTYzLjU2NS02My41NjUgICAgIHMyOC40NDUtNjMuNTY1LDYzLjU2NS02My41NjVzNjMuNTY1LDI4LjQ0NSw2My41NjUsNjMuNTY1UzI4OS4zNzksNDEzLjE3MiwyNTQuMjYsNDEzLjE3MnoiIGRhdGEtb3JpZ2luYWw9IiMwMTAwMDIiIGNsYXNzPSJhY3RpdmUtcGF0aCIgZGF0YS1vbGRfY29sb3I9IiNmZmZmZmYiPjwvcGF0aD4KCQk8L2c+Cgk8L2c+CjwvZz48L2c+IDwvc3ZnPg==" /></button>
</template>

<script>
    //import { Utility } from '../../configs/configpaths';
    export default {
        data: function () {
            return {
                ShowLogOut: false
            }
        },
        mounted: function () {

            this.ShowLogOut = this.$parent.IsLogged();
           
        },
        methods: {
           
        }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.btn.btn-icon{
  position: fixed!important;
  right:10px;
  top:10px;
  z-index:100;
  img{width:20px;height:20px;position: relative;left:-4px;top:-2px;}
}
</style>
